import React from 'react';

import SwipeableViews from 'react-swipeable-views';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import colors from './colors.js';

const styles = {
  root: {
   marginTop: "16px",
   paddingLeft: 0,
   paddingRight: "82px",
  },
  slideContainer: {
    padding: '0 10px',
  },
  slide: {
    padding: 15,
    minHeight: 100,
    color: '#fff',
  },
};

const useStyles = makeStyles(theme => ({
  doctorCarouselSwipeableContainer: {
    marginTop: theme.spacing(1),
  },
  doctorCarousel: {
    paddingTop: theme.spacing(2),
    height: theme.spacing(24),
    width: "100%",
  },
  carouselAvatar: {
    height: theme.spacing(8),
    width: theme.spacing(8),
    marginRight: theme.spacing(3),
  },
  doctorCarouselCard: {
    padding: theme.spacing(2),
    height: theme.spacing(12),
    width: theme.spacing(32),
    backgroundColor: colors.darkgrey,
    border: `0.5px solid ${colors.grey}`,
  },
}));


export const DoctorCarousel = (props) => {
  const classes = useStyles();
  return (
    <SwipeableViews
      style={styles.root}
      slideStyle={styles.slideContainer}
      onChangeIndex={i => {
        props.setHoverDoctor(props.doctorsList[i]?.id);
      }}
    >
      {props.doctorsList.map(d =>
        <Card
            className={classes.doctorCarouselCard}
            onClick={() => { props.selectDoctor(d) }}
        >
          <div style={{
            display: "flex",
          }}>
            <img className={classes.carouselAvatar} src={"https:" + d.avatar?.fields?.file?.url} alt={"avatar"} />
            <div>
              <p
                style={{
                  color: colors.blue,
                  fontSize: "16px",
                  margin: 0,
                }}
              >
                <bold>{d.name}</bold>
              </p>
              <p
                style={{
                  color: colors.blue,
                  fontSize: "12px",
                  margin: 0,
                }}
              >
                {d.specialty}
              </p>
              <p
                style={{
                  color: colors.blue,
                  fontSize: "12px",
                  margin: 0,
                }}
              >
                {d.city}
              </p>
            </div>
          </div>
        </Card>
      )}
    </SwipeableViews>
  );
}
